export const getValidProfilePhoto = (user: any, userProfile: any): string => {
  // Check Google photo URL first
  if (user?.photoURL && !user.photoURL.startsWith('blob:') && user.photoURL.startsWith('https://')) {
    return user.photoURL;
  }
  
  // Check stored profile photo
  if (userProfile?.profilePhoto && !userProfile.profilePhoto.startsWith('blob:') && userProfile.profilePhoto.startsWith('https://')) {
    return userProfile.profilePhoto;
  }
  
  // Generate avatar with initials
  const name = user?.displayName || user?.email || 'User';
  const initials = name.split(' ').map((n: string) => n[0]).join('').toUpperCase();
  
  return `https://ui-avatars.com/api/?name=${initials}&background=0066cc&color=fff&size=128`;
};

export const cleanBlobUrls = (profile: any): any => {
  if (!profile) return profile;
  
  const cleaned = { ...profile };
  
  // Remove blob URLs from profile
  if (cleaned.profilePhoto && cleaned.profilePhoto.startsWith('blob:')) {
    delete cleaned.profilePhoto;
  }
  
  return cleaned;
};




